var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDataLoaded)?_c('task-page',{staticClass:"font-degular max-w-2xl"},[_c('task-list',{attrs:{"log":_vm.log}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }